class step1 {
  constructor(
    firstName,
    lastName,
    isUnknown,
    yearOfAge,
    monthOfAge,
    ageTotalDays,
    nationalCode,
    nationality,
    gender,
    clothesColorAndType,
    specialCharacteristic,
    arriveToPatientTime,
    dateOfOnset,
    id,
    chiefComplaintText,
    doctorConsultationTypeId,
    resuscitationTypeId,
    missionPhoneId,
    birthDate,
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.isUnknown = isUnknown;
    this.yearOfAge = yearOfAge;
    this.monthOfAge = monthOfAge;
    this.ageTotalDays = ageTotalDays;
    this.nationalCode = nationalCode;
    this.nationality = nationality;
    this.gender = gender;
    this.clothesColorAndType = clothesColorAndType;
    this.specialCharacteristic = specialCharacteristic;
    this.arriveToPatientTime = arriveToPatientTime;
    this.dateOfOnset = dateOfOnset;
    this.id = id;
    this.chiefComplaintText = chiefComplaintText;
    this.doctorConsultationTypeId = doctorConsultationTypeId;
    this.resuscitationTypeId = resuscitationTypeId;
    this.missionPhoneId = missionPhoneId;
    this.birthDate = birthDate;
  }
}
class Step2 {
  constructor(
    consciousnessLevelId,
    airwayId,
    respirationId,
    bloodCirculationId,
    isCritical,
    patientId,
    assessmentDate,
  ) {
    this.consciousnessLevelId = consciousnessLevelId;
    this.airwayId = airwayId;
    this.respirationId = respirationId;
    this.bloodCirculationId = bloodCirculationId;
    this.isCritical = isCritical;
    this.patientId = patientId;
    this.assessmentDate = assessmentDate;
  }
}
class PatientMovementAbility {
  constructor(leftHand, leftLeg, rightHand, rightLeg) {
    this.leftHand = leftHand;
    this.leftLeg = leftLeg;
    this.rightHand = rightHand;
    this.rightLeg = rightLeg;
  }
}
class PatientTraumaDetail {
  constructor(
    transitType,
    vehicleType,
    patientState,
    releaseBefore,
    releaseAfter,
    policeCode,
    vehiclePlateNumber,
  ) {
    this.transitType = transitType;
    this.vehicleType = vehicleType;
    this.patientState = patientState;
    this.releaseBefore = releaseBefore;
    this.releaseAfter = releaseAfter;
    this.policeCode = policeCode;
    this.vehiclePlateNumber = vehiclePlateNumber;
  }
}
class Step3 {
  constructor(
    typeOfEmergencyId = null,
    diagnosis = '',
    diagnosisDetail = '',
    patientId = null,
    fallHeight = null,
    patientMovementAbility = null,
    patientTraumaDetail = null,
    patientParturitionDetail = null,
    patientParturitionBabies = null
  ) {
    this.typeOfEmergencyId = typeOfEmergencyId;
    this.diagnosis = diagnosis;
    this.diagnosisDetail = diagnosisDetail;
    this.patientId = patientId;
    this.fallHeight = fallHeight;
    this.patientMovementAbility = patientMovementAbility || new PatientMovementAbility();
    this.patientTraumaDetail = patientTraumaDetail || new PatientTraumaDetail();
    this.patientParturitionDetail = patientParturitionDetail || new PatientParturitionDetail();
    this.patientParturitionBabies = patientParturitionBabies || [];
  }
}
class PatientParturitionDetail {
  constructor(
    beforeCodeArrival = null,
    isMultiple = null,
    pregnancyAge = null,
    numberOfParturition = null,
    numberOfMiscarriage = null,
    numberOfSuccessfulParturition = null,
    hasParturitionDone = null
  ) {
    this.beforeCodeArrival = beforeCodeArrival;
    this.isMultiple = isMultiple;
    this.pregnancyAge = pregnancyAge;
    this.numberOfParturition = numberOfParturition;
    this.numberOfMiscarriage = numberOfMiscarriage;
    this.numberOfSuccessfulParturition = numberOfSuccessfulParturition;
    this.hasParturitionDone = hasParturitionDone;
  }
}
class PatientParturitionBabies {
  constructor(
    gender = null,
    isFetalPlacentaOut = null,
    totalScore = null,
    patientId = null,
    fetalPositionId = null,
    patientApgarDetails = null,
    parturitionDate = null
  ) {
    this.gender = gender;
    this.isFetalPlacentaOut = isFetalPlacentaOut;
    this.totalScore = totalScore;
    this.patientId = patientId;
    this.fetalPositionId = fetalPositionId;
    this.parturitionDate = parturitionDate;
    this.patientApgarDetails = patientApgarDetails || [];
  }
}
class PatientApgarDetails {
  constructor(
    timeInSeconds = null,
    patientApgarType = null,
    heartBeatId = null,
    muscleToneId = null,
    babyRespirationId = null,
    babyReactionToStimulationId = null,
    babyBodyColorId = null
  ) {
    this.timeInSeconds = timeInSeconds;
    this.patientApgarType = patientApgarType;
    this.heartBeatId = heartBeatId;
    this.muscleToneId = muscleToneId;
    this.babyRespirationId = babyRespirationId;
    this.babyReactionToStimulationId = babyReactionToStimulationId;
    this.babyBodyColorId = babyBodyColorId;
  }
}
class Step4 {
  constructor(
    observationDate,
    painScale,
    temperature,
    respiratoryRate,
    bloodSugar,
    pulseRate,
    systolicBloodPressure,
    diastolicBloodPressure,
    spO2,
    e4,
    v5,
    m6,
    gcs,
    gapIndexScore,
    riskAlignment,
    patientId,
  ) {
    this.observationDate = observationDate;
    this.painScale = painScale;
    this.temperature = temperature;
    this.respiratoryRate = respiratoryRate;
    this.bloodSugar = bloodSugar;
    this.pulseRate = pulseRate;
    this.systolicBloodPressure = systolicBloodPressure;
    this.diastolicBloodPressure = diastolicBloodPressure;
    this.spO2 = spO2;
    this.e4 = e4;
    this.v5 = v5;
    this.m6 = m6;
    this.gcs = gcs;
    this.gapIndexScore = gapIndexScore;
    this.riskAlignment = riskAlignment;
    this.patientId = patientId;
  }
}
class PatientBeFastDetail {
  constructor(imbalance, visionChanges, saggingFace, paralysis, talkingProblem) {
    this.imbalance = imbalance;
    this.visionChanges = visionChanges;
    this.saggingFace = saggingFace;
    this.paralysis = paralysis;
    this.talkingProblem = talkingProblem;
  }
}
class patientRespiratoryDetail {
  constructor(hasActivityBreathProblem) {
    this.hasActivityBreathProblem = hasActivityBreathProblem;
  }
}
class PatientChestPainDetail {
  constructor(
    isActivityPain,
    chestPainTypeId,
    chestPainLocationId,
    chestPainPropagationId,
    chestPainDurationId,
    painScale,
  ) {
    this.isActivityPain = isActivityPain;
    this.chestPainTypeId = chestPainTypeId;
    this.chestPainLocationId = chestPainLocationId;
    this.chestPainPropagationId = chestPainPropagationId;
    this.chestPainDurationId = chestPainDurationId;
    this.painScale = painScale;
  }
}
class PatientHeadacheDetail {
  constructor(headacheTypeId, headacheLocationId, headacheOtherSignId) {
    this.headacheTypeId = headacheTypeId;
    this.headacheLocationId = headacheLocationId;
    this.headacheOtherSignId = headacheOtherSignId;
  }
}
class PatientVertigoDetail {
  constructor(vertigoTypeId, vertigoDurationId, vertigoAggravatingFactorId) {
    this.vertigoTypeId = vertigoTypeId;
    this.vertigoDurationId = vertigoDurationId;
    this.vertigoAggravatingFactorId = vertigoAggravatingFactorId;
  }
}
class PatientAbdomenPainDetails {
  constructor(partNumber) {
    this.partNumber = partNumber;
  }
}
class PatientHeadacheOtherSpecificationDetails {
  constructor(headacheOtherSpecificationId, note) {
    this.headacheOtherSpecificationId = headacheOtherSpecificationId;
    this.note = note;
  }
}
class PatientHeadacheIllnessHistories {
  constructor(headacheIllnessHistoryId) {
    this.headacheIllnessHistoryId = headacheIllnessHistoryId;
  }
}
class PatientVertigoOtherSpecifications {
  constructor(vertigoOtherSpecificationId, note) {
    this.vertigoOtherSpecificationId = vertigoOtherSpecificationId;
    this.note = note;
  }
}
class Step5 {
  constructor(
    title,
    patientId,
    patientBeFastDetail,
    patientRespiratoryDetail,
    patientChestPainDetail,
    patientHeadacheDetail,
    patientVertigoDetail,
    patientAbdomenPainDetails,
    patientHeadacheOtherSpecificationDetails,
    patientHeadacheIllnessHistories,
    patientVertigoOtherSpecifications,
  ) {
    this.title = title;
    this.patientId = patientId;
    this.patientBeFastDetail = patientBeFastDetail;
    this.patientRespiratoryDetail = patientRespiratoryDetail;
    this.patientChestPainDetail = patientChestPainDetail;
    this.patientHeadacheDetail = patientHeadacheDetail;
    this.patientVertigoDetail = patientVertigoDetail;
    this.patientAbdomenPainDetails = patientAbdomenPainDetails;
    this.patientHeadacheOtherSpecificationDetails = patientHeadacheOtherSpecificationDetails;
    this.patientHeadacheIllnessHistories = patientHeadacheIllnessHistories;
    this.patientVertigoOtherSpecifications = patientVertigoOtherSpecifications;
  }
}
class Step6 {
  constructor(title, patientId) {
    this.title = title;
    this.patientId = patientId;
  }
}
class Step8 {
  constructor(title, isAllergic, patientId) {
    this.title = title;
    this.isAllergic = isAllergic;
    this.patientId = patientId;
  }
}
class PatientAbdominalExamination {
  constructor(partNumber, abdomenExaminationId) {
    this.partNumber = partNumber;
    this.abdomenExaminationId = abdomenExaminationId;
  }
}
class PatientBrainStrokeExaminationDetail {
  constructor(leftHand, rightHand, rightLeg, leftLeg) {
    this.leftHand = leftHand;
    this.rightHand = rightHand;
    this.rightLeg = rightLeg;
    this.leftLeg = leftLeg;
  }
}
class PatientPupilExamination {
  constructor(
    rightNormal,
    leftNormal,
    rightDilate,
    leftDilate,
    rightMiotic,
    leftMiotic,
    rightNoAnswer,
    leftNoAnswer,
  ) {
    this.rightNormal = rightNormal;
    this.leftNormal = leftNormal;
    this.rightDilate = rightDilate;
    this.leftDilate = leftDilate;
    this.rightMiotic = rightMiotic;
    this.leftMiotic = leftMiotic;
    this.rightNoAnswer = rightNoAnswer;
    this.leftNoAnswer = leftNoAnswer;
  }
}
class PatientRespiratorySoundDetail {
  constructor(
    rightFineRale,
    leftFineRale,
    rightCoarseRale,
    leftCoarseRale,
    rightWheeze,
    leftWheeze,
    rightSoundReduction,
    leftSoundReduction,
  ) {
    this.rightFineRale = rightFineRale;
    this.leftFineRale = leftFineRale;
    this.rightCoarseRale = rightCoarseRale;
    this.leftCoarseRale = leftCoarseRale;
    this.rightWheeze = rightWheeze;
    this.leftWheeze = leftWheeze;
    this.rightSoundReduction = rightSoundReduction;
    this.leftSoundReduction = leftSoundReduction;
  }
}
class Step9 {
  constructor(
    hadHeartMonitoring,
    heartRhythmId,
    heartSoundId,
    respiratorySoundId,
    pulseQualityId,
    pulseRhythmId,
    skinTurgorId,
    skinTemperatureId,
    skinExaminationId,
    lastFood,
    lastFoodDate,
    hasNystagmus,
    hasVaginalBleeding,
    hasEyeDeviation,
    otherSymptoms,
    patientId,
    patientAbdominalExaminations,
    patientBrainStrokeExaminationDetail,
    patientPupilExamination,
    patientRespiratorySoundDetail,
  ) {
    this.hadHeartMonitoring = hadHeartMonitoring;
    this.heartRhythmId = heartRhythmId;
    this.heartSoundId = heartSoundId;
    this.respiratorySoundId = respiratorySoundId;
    this.pulseQualityId = pulseQualityId;
    this.pulseRhythmId = pulseRhythmId;
    this.skinTurgorId = skinTurgorId;
    this.skinTemperatureId = skinTemperatureId;
    this.skinExaminationId = skinExaminationId;
    this.lastFood = lastFood;
    this.lastFoodDate = lastFoodDate;
    this.hasNystagmus = hasNystagmus;
    this.hasVaginalBleeding = hasVaginalBleeding;
    this.hasEyeDeviation = hasEyeDeviation;
    this.otherSymptoms = otherSymptoms;
    this.patientId = patientId;
    this.patientAbdominalExaminations = patientAbdominalExaminations;
    this.patientBrainStrokeExaminationDetail = patientBrainStrokeExaminationDetail;
    this.patientPupilExamination = patientPupilExamination;
    this.patientRespiratorySoundDetail = patientRespiratorySoundDetail;
  }
}
class Step10 {
  constructor(bodyPartId, patientId, isFront, typeOfInjuries) {
    this.bodyPartId = bodyPartId;
    this.patientId = patientId;
    this.isFront = isFront;
    this.typeOfInjuries = typeOfInjuries;
  }
}
class Step12 {
  constructor(drugId, actionDate, drugOrderTypeId, dosage, patientId) {
    this.drugId = drugId;
    this.actionDate = actionDate;
    this.drugOrderTypeId = drugOrderTypeId;
    this.dosage = dosage;
    this.patientId = patientId;
  }
}
class Step13 {
  constructor(medicalItemId, count, patientId) {
    this.medicalItemId = medicalItemId;
    this.count = count;
    this.patientId = patientId;
  }
}
class Step14 {
  constructor(resultId, information, patientId, note) {
    this.resultId = resultId;
    this.information = information;
    this.patientId = patientId;
    this.note = note;
  }
}

export default {
  step1,
  Step2,
  PatientMovementAbility,
  PatientTraumaDetail,
  PatientParturitionDetail,
  PatientApgarDetails,
  PatientParturitionBabies,
  Step3,
  Step4,
  PatientBeFastDetail,
  patientRespiratoryDetail,
  PatientChestPainDetail,
  PatientHeadacheDetail,
  PatientVertigoDetail,
  PatientAbdomenPainDetails,
  PatientHeadacheOtherSpecificationDetails,
  PatientHeadacheIllnessHistories,
  PatientVertigoOtherSpecifications,
  Step5,
  Step6,
  Step8,
  PatientAbdominalExamination,
  PatientBrainStrokeExaminationDetail,
  PatientPupilExamination,
  PatientRespiratorySoundDetail,
  Step9,
  Step10,
  Step12,
  Step13,
  Step14,
};
